export default "__VITE_ASSET__T5XfIJmc__"